import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import {
  ErrorResponse,
  ListResponse,
  Transaction,
  TransactionMethodCategory,
} from 'types';

const useTransactions = ({
  queries,
}: {
  queries: {
    status?: Transaction['status'];
    from_date?: string;
    to_date?: string;
    category?: TransactionMethodCategory;
    'transaction_method.category'?: TransactionMethodCategory;
  };
}): UseQueryResult<ListResponse<Transaction>, ErrorResponse> => {
  let queryParams = '?';
  if (Object.entries(queries).length > 0) {
    Object.entries(queries).map(([key, value], i) => {
      queryParams += `${key}=${value}${
        i === Object.entries(queries).length - 1 ? '' : '&'
      }`;
    });
  }

  return useQuery([`${url.transactions}${queryParams}`]);
};
export default useTransactions;
